const ROOT_URL = 'https://api.917.cn'
// const ROOT_URL = 'http://api.917.test'
module.exports = {
  BASE_URL: ROOT_URL,
  IMG_URL: ROOT_URL + '/storage/',
  API_PATH: ROOT_URL + '/api', // 接口地址
  IMAGE_UPLOAD_PATH: ROOT_URL + '/api/upload/image', // 图片上传地址
  STORAGE_KEY: 'user-info', // 用户信息
	TOKEN_KEY: 'token'
}
